import stringify from 'fast-json-stable-stringify';
// for any given string (stringified object), always get the same 16-char hex string
// guarantees exactly 8 hex digits, so keys are all the same length
// collision risk: it’s a 32-bit hash, so there are billions of possible outputs, so no risks
export const hashStringToHex = (str) => {
    let hash = 5381n;
    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5n) + hash) ^ BigInt(str.charCodeAt(i));
        hash &= 0xffffffffffffffffn; // clamp to 64 bits
    }
    return hash.toString(16).padStart(16, '0');
};
/**
 * stable, canonical JSON stringifier.
 * delegates everything to fast-json-stable-stringify so we
 * keep deterministic key ordering and full JSON-compat edge-case handling.
 */
export function stableStringify(x) {
    return stringify(x);
}
export function stripHtmlTags(str) {
    return str.replace(/<[^>]*>/g, '');
}
export const arrayIfy = (arrayOrString) => {
    if (Array.isArray(arrayOrString)) {
        return arrayOrString;
    }
    return arrayOrString ? [arrayOrString] : [];
};
